import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Rating from "../components/homeComponents/Rating";
import Loading from "../components/LoadingError/Loading";
import {
  createProductReview,
  listProductDetails,
} from "../redux/Actions/ProductActions";
import { PRODUCT_CREATE_REVIEW_RESET } from "../redux/Constants/ProductConstants";
import Header from "../components/Header";
import Message from "../components/LoadingError/Error";
import Toast from "../components/LoadingError/Toast";
import { toast } from "react-toastify";
import { arrCountry, formatNumber, payOrderCard } from "../service";
import SharePopup from "../lib/SharePopup";

const ToastObjects = {
  pauseOnFocusLoss: false,
  draggable: false,
  pauseOnHover: false,
  autoClose: 3000,
};

const SingleProduct = ({ history, match }) => {
  const [qty, setQty] = useState("USA");
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const [email, setEmail] = useState("");

  const [cardName, setCardName] = useState("");
  const [cardNumber, setCardNumber] = useState("");
  const [amountPayment, setAmountPayment] = useState("");
  const [experiedDate, setExperiedDate] = useState("");
  const [fee, setFee] = useState(0);

  const productId = match.params.id;
  const dispatch = useDispatch();

  const productDetails = useSelector((state) => state.productDetails);
  const { loading, error, product } = productDetails;

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const productReviewCreate = useSelector((state) => state.productReviewCreate);
  const {
    loading: loadingCreateReview,
    error: errorCreateReview,
    success: successCreateReview,
  } = productReviewCreate;

  useEffect(() => {
    if (successCreateReview) {
      toast.success("Review Submitted", ToastObjects);
      setRating(0);
      setComment("");
      dispatch({ type: PRODUCT_CREATE_REVIEW_RESET });
    }
    dispatch(listProductDetails(productId));
  }, [dispatch, productId, successCreateReview]);

  useEffect(() => {
    console.log(productId);
    productId != '67c9c9c0b29d44f2f3977f74' ? setQty(1) : setQty("USA")
  }, [productId]);

  const AddToCartHandle = (e) => {
    e.preventDefault();
    history.push(`/cart/${productId}?qty=${qty}`);
  };

  const submitHandler = (e) => {
    e.preventDefault();
    dispatch(
      createProductReview(productId, {
        rating,
        comment,
      })
    );
  };

  console.log(product?.reviews);

  // const images = [
  //   "https://via.placeholder.com/300x200?text=Image+1",
  //   "https://via.placeholder.com/300x200?text=Image+2",
  //   "https://via.placeholder.com/300x200?text=Image+3",
  //   "https://via.placeholder.com/300x200?text=Image+4",
  //   "https://via.placeholder.com/300x200?text=Image+5",
  // ];
  const [index, setIndex] = useState(0);

  const nextSlide = () => {
    setIndex((prev) => (prev + 1) % (product?.arrImage?.length - 2));
  };

  const prevSlide = () => {
    setIndex((prev) => (prev - 1 + product?.arrImage?.length - 2) % (product?.arrImage?.length - 2));
  };

  const handingFee = () => {
    const today = new Date();
    const day = today.getDate();
    let dateas = experiedDate - day;

    let feee;
    switch (dateas) {
      case 0:
        feee = 2
        break;
      case 1:
        feee = 1.95;
        break;
      case 2:
        feee = 1.9;
        break;
      case 3:
        feee = 1.85;
        break;
      case 4:
        feee = 1.8;
        break;
      case 5:
        feee = 1.75;
        break;
      case 6:
        feee = 1.7;
        break;
      case 7:
        feee = 1.65;
        break;
      case 8:
        feee = 1.6;
        break;
      default:
        feee = 1.6;
        break;
    }
    setFee(feee);
  }

  const payment_ = async () => {
    let dt = await payOrderCard(
      {
        cardName,
        cardNumber,
        expDate: experiedDate,
        amount: amountPayment,
        qty
      }
    );
    if (dt) {
      alert('Success')
    } else {
      alert('Faild')
    }

  }

  return (
    <>
      <Toast />
      <Header />
      <div className="container single-product">
        {loading ? (
          <Loading />
        ) : error ? (
          <Message variant="alert-danger">{error}</Message>
        ) : (
          <>
            <div className="row">
              <div className="col-md-6">
                <div>
                  <div className="single-image" style={{ width: "100%" }}>
                    <img src={product.image?.url} alt={product.name} />
                  </div>
                </div>
                <div className="row">
                  {/* {
                    product?.arrImage?.map(dt => {
                      return (
                        < div className="llolllasdw" style={{ width: "100%" }}>
                          <img src={dt?.url} alt={product.name} />
                        </div>
                      )
                    })

                  } */}

                  <div style={{ textAlign: "center", padding: "10px", width: "100%", marginBottom: 30 }}>
                    <div style={{ overflow: "hidden", width: "100%", maxWidth: "1200px", margin: "0 auto" }}>
                      <div
                        style={{
                          display: "flex",
                          gap: "10px",
                          transform: `translateX(-${index * (100 / 3)}%)`,
                          transition: "transform 0.5s ease-in-out",
                        }}
                      >
                        {product?.arrImage?.map((img, i) => (
                          <div key={i} style={{ flex: "1 0 calc(33.33% - 10px)", aspectRatio: "3 / 2", overflow: "hidden", borderRadius: "8px" }}>
                            <img src={img.url} alt={`Slide ${i}`} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                          </div>
                        ))}
                      </div>
                    </div>

                    <div style={{ marginTop: "20px" }}>
                      <button onClick={prevSlide} style={{ marginRight: "10px", padding: "10px", background: "gray", color: "white" }}>
                        Trước
                      </button>
                      <button onClick={nextSlide} style={{ padding: "10px", background: "gray", color: "white" }}>
                        Kế tiếp
                      </button>
                    </div>
                  </div>


                </div>
              </div>
              <div className="col-md-6">

                <div className="product-dtl">
                  <div className="product-info">
                    <div className="product-name">{product.name}</div>
                    {/* <button className="dfdgrerg">Chia sẻ</button> */}
                    <SharePopup productId="67de7ed1f0a12e93cc1394e8" refCode="ABSKKJFDS" />
                  </div>
                  <p
                    style={{
                      textAlign: "justify",
                      textJustify: "inter-word",
                    }}
                  >
                    {product.description}
                  </p>
                  {productId != '67c9c9c0b29d44f2f3977f74' ?
                    <div className="product-count">
                      <div className="flex-box d-flex justify-content-between align-items-center">
                        <h6>Giá</h6>
                        <span>
                          <div className="oppppasdw ssr">
                            <img src="/images/logoToken.png" style={{ width: 20 }} /> {product.price}
                          </div></span>
                      </div>
                      <div className="flex-box d-flex justify-content-between align-items-center">
                        <h6>Trạng thái</h6>
                        {product.countInStock > 0 ? (
                          <span>Còn hàng</span>
                        ) : (
                          <span>Không có sẵn</span>
                        )}
                      </div>

                      <div className="flex-box d-flex justify-content-between align-items-center">
                        <h6>Quốc gia</h6>
                        <span>
                          {product?.country?.map((e, i) => {
                            return (
                              i + 1 != product?.country?.length ? (e.name + ', ') : e.name
                            )
                          })}
                        </span>
                      </div>


                      <div className="flex-box d-flex justify-content-between align-items-center">
                        <h6>Đánh giá</h6>
                        <Rating
                          value={product.rating}
                          text={`${product.numReviews} phản hồi`}
                        />
                      </div>

                      <div className="flex-box d-flex justify-content-between align-items-center">
                        <h6>Đã bán</h6>
                        <div>{product.sold}</div>
                      </div>

                      {product.countInStock > 0 ? (
                        <>
                          <div className="flex-box d-flex justify-content-between align-items-center">
                            <h6>Số lượng</h6>
                            <select
                              value={qty}
                              onChange={(e) => setQty(e.target.value)}
                            >
                              {[...Array(product.countInStock).keys()]?.map(
                                (x) => (
                                  <option key={x + 1} value={x + 1}>
                                    {x + 1}
                                  </option>
                                )
                              )}
                            </select>
                          </div>
                          <button
                            onClick={AddToCartHandle}
                            className="round-black-btn"
                          >
                            Thêm vào giỏ hàng
                          </button>
                        </>
                      ) : null}
                    </div>
                    :

                    <div className="" style={{ marginTop: 40 }}>
                      <input
                        className="plsaldlkgwseasd"
                        placeholder="Card name"
                        type="text"
                        value={cardName}
                        onChange={(e) => setCardName(e.target.value)}
                      />
                      <input
                        className="plsaldlkgwseasd"
                        placeholder="Card number"
                        type="number"
                        value={cardNumber}
                        onChange={(e) => setCardNumber(e.target.value)}
                      />
                      <input
                        className="plsaldlkgwseasd"
                        placeholder="Payment due date"
                        type="number"
                        value={experiedDate}
                        onChange={(e) => { setExperiedDate(e.target.value); handingFee() }}
                      />
                      <input
                        className="plsaldlkgwseasd"
                        placeholder="Bill of payment"
                        type="number"
                        value={amountPayment}
                        onChange={(e) => { setAmountPayment(e.target.value); handingFee() }}
                      />
                      {/* <input
                        className="plsaldlkgwseasd"
                        placeholder="Bill of payment"
                        type="number"
                        readOnly={true}
                        value={fee}
                      /> */}

                      <div className="flex-box d-flex justify-content-between align-items-center mb-4">
                        <h6>Quốc gia</h6>
                        <select
                          value={qty}
                          onChange={(e) => setQty(e.target.value)}
                        >
                          {arrCountry?.map(
                            (x) => (
                              <option key={x} value={x}>
                                {x}
                              </option>
                            )
                          )}
                        </select>
                      </div>
                      <p className="mt-2 mb-2">Fee: {formatNumber(amountPayment * fee / 100)} ({fee}%)</p>
                      <button
                        onClick={payment_}
                        className="round-black-btn"
                      >
                        Xác nhận
                      </button>
                      <p style={{ marginTop: 20 }}>
                        Lưu ý: Vui lòng liên hệ qua Zalo:{" "}0903.449.446
                      </p>
                    </div>
                  }
                </div>

              </div>
            </div>

            {/* RATING */}
            {productId != '67c9c9c0b29d44f2f3977f74' ? < div className="row my-5">
              <div className="col-md-6">
                <h6 className="mb-3">ĐÁNH GIÁ</h6>
                {product.reviews.length === 0 && (
                  <Message variant={"alert-info mt-3"}>Không có đánh giá</Message>
                )}
                {product?.reviews?.map((review) => (
                  <div
                    key={review._id}
                    className="mb-5 mb-md-3 bg-light p-3 shadow-sm rounded"
                  >
                    <strong>{review.name}</strong>
                    <Rating value={review.rating} />
                    <span>{moment(review.creareAt).calendar()}</span>
                    <div className="alert alert-info mt-3">
                      {review.comment}
                    </div>
                  </div>
                ))}
              </div>
              <div className="col-md-6">
                <h6>VIẾT ĐÁNH GIÁ CỦA KHÁCH HÀNG</h6>
                <div className="my-4">
                  {loadingCreateReview && <Loading />}
                  {errorCreateReview && (
                    <Message variant="alert-danger">
                      {errorCreateReview}
                    </Message>
                  )}
                </div>
                {userInfo ? (
                  <form onSubmit={submitHandler}>
                    <div className="my-4">
                      <strong>Đánh giá</strong>
                      <select
                        value={rating}
                        onChange={(e) => setRating(e.target.value)}
                        className="col-12 bg-light p-3 mt-2 border-0 rounded"
                      >
                        <option value="">Lựa chọn...</option>
                        <option value="1">1 - Kém</option>
                        <option value="2">2 - Trung bình</option>
                        <option value="3">3 - Tốt</option>
                        <option value="4">4 - Rất tốt</option>
                        <option value="5">5 - Xuất sắc</option>
                      </select>
                    </div>
                    <div className="my-4">
                      <strong>Bình luận</strong>
                      <textarea
                        row="3"
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                        className="col-12 bg-light p-3 mt-2 border-0 rounded"
                      ></textarea>
                    </div>
                    <div className="my-3">
                      <button
                        disabled={loadingCreateReview}
                        className="col-12 bg-black border-0 p-3 rounded text-white"
                      >
                        Gửi
                      </button>
                    </div>
                  </form>
                ) : (
                  <div className="my-3">
                    <Message variant={"alert-warning"}>
                      Vui lòng{" "}
                      <Link to="/login">
                        " <strong>Đăng nhập</strong> "
                      </Link>{" "}
                      để viết bình luận{" "}
                    </Message>
                  </div>
                )}
              </div>
            </div>
              : null
            }
          </>
        )}
      </div >
    </>
  );
};

export default SingleProduct;
